import React from 'react';
import MarketCapLossesComponent from "./MarketCapLossesComponent";
import {padCalendar} from "../../../util";

function formatMarketCapitalizationLosses(marketCapitalizationLosses) {
    for (const marketCapitalizationLoss of marketCapitalizationLosses) {
        marketCapitalizationLoss.date = padCalendar(marketCapitalizationLoss.date);
    }

    return marketCapitalizationLosses;
}

const MarketCapLossesContainer = (props) => {

    if (!props.marketCapitalizationLosses) {
        return <div>Loading</div>
    }

    const data = formatMarketCapitalizationLosses(props.marketCapitalizationLosses);

    return (
        <React.Fragment>
            <MarketCapLossesComponent marketCapitalizationLosses={data} isDandO={sessionStorage.getItem('DANDO')} claimTypeId={props.claimTypeId}/>
        </React.Fragment>
    );

};


export default MarketCapLossesContainer;


// WEBPACK FOOTER //
// ./src/common/components/MarketCapLosses/MarketCapLossesContainer.js